import { Link } from 'react-router-dom';
import { SEO } from '@/components/SEO';

export function NotFoundPage() {
  return (
    <div className="max-w-3xl mx-auto px-4 py-24 sm:py-28 text-center">
      <SEO
        title="Page not found — ACES"
        description="That page doesn't exist on ACES. Head back to the home page to find your chapter."
      />
      <p className="font-sans text-sm font-semibold uppercase tracking-[0.2em] text-accent-600">404</p>
      <h1 className="font-serif text-5xl sm:text-6xl text-ink-900 mt-3 tracking-tight leading-[1.05]">Lost in the <span className="italic text-accent-600">ledger?</span></h1>
      <p className="text-ink-500 mt-3">That page didn't balance. Let's reset.</p>
      <Link
        to="/"
        className="aces-btn-primary mt-8"
      >
        ← Home
      </Link>
    </div>
  );
}
